import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import { validatePath, replaceParams } from "./internal"; // The first time the routes are loaded, iterate through them and create the named
// route functions.

var namedRoutes = {};
var namedRoutesDone = false;

var mapNamedRoutes = function mapNamedRoutes(routes) {
  if (namedRoutesDone) {
    return;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var route = _step.value;
      var _route$props = route.props,
          path = _route$props.path,
          name = _route$props.name,
          notfound = _route$props.notfound; // Skip the notfound route.

      if (notfound) {
        return "continue";
      } // Check for issues with the path.


      validatePath(path); // Create the named route function for this route.

      namedRoutes[name] = function () {
        var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return replaceParams(path, args);
      };
    };

    for (var _iterator = _getIterator(routes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    } // Only need to do this once.

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  namedRoutesDone = true;
};

var routes = namedRoutes;
export { routes, mapNamedRoutes };